
import {defineComponent} from 'vue'
import Lien from "../../common/components/ob1/Lien.vue";
import Price from "../../common/components/ob1/Price.vue";
import {TrackedLinkDto} from "../../common/ob1/dto/TrackedLinkDto";
import {VisualDto} from "../models/InternetAndMobileApiResponse";
import {PriceDto, PromotionType} from "../../common/components/ob1/models/Price";

export default defineComponent({
    name: "InternetAndMobileCardContent",
    components: {Price, Lien},
    props: {
        offerName: {
            type: String,
            required: true
        },
        price: {
            type: Object as () => PriceDto,
            required: true
        },
        detailLink: {
            type: Object as () => TrackedLinkDto,
            required: true
        },
        visual: {
            type: Object as () => VisualDto,
            required: true
        },
        backgroundVisual: {
            type: Object as () => VisualDto,
            required: false,
            default: undefined
        },
        prefixWrapper: {
            type: String,
            required: false,
            default: undefined
        }
    },
    computed: {
        showPromoDuration(): boolean {
            return this.price.promotionType === PromotionType.PROMO_DURATION.toString();
        },
        showPromoDurationFirstMonths(): boolean {
            return this.price.promotionType === PromotionType.PROMO_DURATION_FIRST_MONTHS.toString();
        },
        showUntilEndOfPromo(): boolean {
            return this.price.promotionType === PromotionType.UNTIL_END_OF_PROMO.toString();
        },
        showEndOfPromotionPrice(): boolean {
            return this.price.promotionType === PromotionType.END_OF_PROMO.toString();
        },
        showChildrenPromotionPrice(): boolean {
            return this.price.promotionType === PromotionType.CHILDREN_PROMOTION.toString();
        }
    },
    methods: {
        getWrapper(wrapperName: string): string {
            return this.prefixWrapper ? `${this.prefixWrapper}-${wrapperName}` : wrapperName;
        }
    }
})
